<template>
  <div id="cpan_wrapper">
    <core-toolbar :drawer="drawer" @toggle-drawer="toggleDrawer" style="z-index:100;"></core-toolbar>
    <router-view name="router_wrapper_kitchen"></router-view>
  </div>
</template>

<script>
export default {
  name: "CPanel",
  data: () => ({
    drawer: false,
  }),
  beforeRouteUpdate(to, from, next) {
    this.drawer = to.path.includes('admin');
    next();
  },
  created() {
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    disable_toolbar() {
      this.drawer = false;
    },
    enable_toolbar() {
      this.drawer = true;
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/cpanel/index.scss';
</style>
